import {
  Service
} from '../service.js'
import {
  env
} from '../env.js'

class TotalizadoresPorTipoService extends Service {
  constructor() {
    super();

    this.url = env.url + "totalizador/dashboard";
  }

  async listar(objetoDeFiltros, removerPagina = false) {
    if(removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(this.url + queryString);
  }
  async listarNomes(objetoDeFiltros, removerPagina = false) {
    if(removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(this.url+'-names' + queryString);
  }
}

export const totalizadoresPorTipoService = new TotalizadoresPorTipoService()
